import { prop } from './prop';
/**
 * Same as `prop`, except that it returns `props.theme[path]` instead of
 * `props[path]`.
 *
 * @example
 * const Button = styled.button`
 *  color: ${themeProp("button.color", "red")};
 * `;
 */
export const themeProp = (path, defaultValue) => (props) => prop(path, defaultValue)(props.theme);
//# sourceMappingURL=themeProp.js.map